module.exports = __webpack_public_path__ + "res/4-img_media_bg.cf35d15226f361c3a841ca409d470054.png";